import { Component, OnInit,Input } from '@angular/core';
import { Building } from '../../../building.model';
import { DataService } from 'src/app/service/buildings.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-building-item',
  templateUrl: './building-item.component.html',
  styleUrls: ['./building-item.component.css']
})
export class BuildingItemComponent implements OnInit {
  @Input() building: Building;
  @Input() index: number;
  buildings: any;
  display='none'; //default Variable
  constructor(private dataService: DataService) { }
showname(index:number)
{
  console.log("index:"+index);
  // this.dataService.getBuilding(index).subscribe(data => {console.log( this.buildings = data); });
  this.openModalDialog();

}
openModalDialog(){
  console.log("open");
  this.display='block'; //Set block css
}

closeModalDialog(){
  console.log("close");
this.display='none'; //set none css after close dialog
}
  ngOnInit() {
  }

}
